define('cartware_checkout/components/advises/billing',[
	"cartware/components/_base",
	"cartware/dom/event/trigger",
	"cartware_checkout"
], function(
	Component,
	triggerEvent,
	CartwareCheckout
) {
	var register;

	CartwareCheckout().retrieve("register", function(reg) {
		register = reg;
	});

	return Component.create({
		init: function() {
			function validationAdvise() {
				var validator = this.validator || new Validation(this.form);

				if ("undefined" != typeof this.validate) {
					if (!this.validate()) {
						return false;
					}
				}

				return validator.validate();
			}

			var _initialize = Billing.prototype.initialize;
			Billing.prototype.initialize = function () {
				_initialize.apply(this, arguments);

				var _onComplete = this.onComplete,
					self = this;

				this.onCompleteQueue = [];

				this.onComplete = function() {
					_onComplete.apply(self, arguments);

					self.onCompleteQueue.clone().each(function(cb) {
						cb.call(self);
						self.onCompleteQueue.splice(self.onCompleteQueue.indexOf(cb), 1);
					});
				}
			};

			Billing.prototype.save = function() {
				if (checkout.loadWaiting!=false) return;

				var validator = new Validation(this.form);

				var params = Form.serialize(this.form);

				if (register && register.isActive()) {
					if (!register.validate()) return;

					params += '&' + Form.serialize(register.getForm());
				}

				if (validator.validate()) {
					checkout.setLoadWaiting('billing');

					var request = new Ajax.Request(
						this.saveUrl,
						{
							method: 'post',
							onComplete: this.onComplete,
							onSuccess: this.onSave,
							onFailure: checkout.ajaxFailure.bind(checkout),
							parameters: params
						}
					);
				}
			};

			var _nextStep = Billing.prototype.nextStep;
			Billing.prototype.nextStep = function(billingTransport) {
				var _setStepResponse = checkout.setStepResponse,
					e = null;

				var billingResponse = {};
				if (billingTransport && billingTransport.responseText) {
					try {
						billingResponse = eval('(' + billingTransport.responseText + ')');
					} catch (e) {
						billingResponse = {};
					}
				}

				try {
					_nextStep.apply(this, arguments);
				} catch (e) {}

				checkout.setStepResponse = _setStepResponse;

				if (e !== null) {
					throw e;
				}

				if ("error" in billingResponse && billingResponse.error) {
					return;
				}

				this.onCompleteQueue.push(function() {
					var _paymentOnSave = payment.onSave;
					var _paymentOnComplete = payment.onComplete;

					payment.onSave = function(paymentTransport) {
						//console.log("payment.onSave");

						var paymentResponse;
						if (paymentTransport && paymentTransport.responseText) {
							try {
								paymentResponse = eval('(' + paymentTransport.responseText + ')');
							} catch (e) {
								paymentResponse = {};
							}
						}

						payment.onSave = _paymentOnSave;
						_paymentOnSave.apply(this, arguments);

						if (!paymentResponse.error) {
							setTimeout(function() {
								//console.log("checkout.setStepResponse(transport)");
								//checkout.loadWaiting = false;
								checkout.setStepResponse(billingResponse);
								checkout.setLoadWaiting(false);
								window.accordion._layout();
							}, 10);
						} else {
							payment.resetLoadWaiting();
							if ("applyStashedCcData" in payment) payment.applyStashedCcData();
						}
					};

					payment.onComplete = function() {
						//console.log("payment.onComplete");
						payment.onComplete = _paymentOnComplete;
					};

					//console.log("payment.save()");
					payment.save();
				});
			};

			Billing.prototype.originalSave = function() {
				_save.apply(this, arguments);
			};

			Billing.prototype.setDifferentFromShipping = function(flag) {
				$('billing:different_from_shipping').checked = flag;
				if (!flag) {
					this.syncWithShipping();
				}
			};

			Billing.prototype.syncWithShipping = function () {
				$('shipping-address-select') && this.newAddress(!$('shipping-address-select').value);
				$('billing:different_from_shipping').checked = false;
				if (!$('shipping-address-select') || !$('shipping-address-select').value) {
					arrElements = Form.getElements(this.form);
					for (var elemIndex in arrElements) {
						if (arrElements[elemIndex].id) {
							var sourceField = $(arrElements[elemIndex].id.replace(/^billing:/, 'shipping:'));
							if (sourceField){
								arrElements[elemIndex].value = sourceField.value;
							}
						}
					}

					if ($('billing:email') && $('customer:email')) {
						$('billing:email').value = $('customer:email').value;
					}

					$('billing:country_id').value = $('shipping:country_id').value;
					//billingRegionUpdater.update();
					triggerEvent($('billing:country_id'), 'change');

					$('billing:region_id').value = $('shipping:region_id').value;
					$('billing:region').value = $('shipping:region').value;
					triggerEvent($('billing:region_id'), 'change');

					//billingForm.elementChildLoad($('billing:country_id'), this.setRegionValue.bind(this));
				} else {
					$('billing-address-select').value = $('shipping-address-select').value;
				}
			};

			var _newAddress = Billing.prototype.newAddress;
			Billing.prototype.newAddress = function(flag) {
				_newAddress.apply(this, arguments);

				if ("accordion" in window) {
					window.accordion._layout();
				}
			};
		}
	});
});
